module.exports = __webpack_public_path__ + "static/01-58c5bdb7b41421dc59eabd68886e946e.png";